import { PickSessionSchema } from "@redotech/redo-model/wms/schema/pick-session";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const markPickSessionItemInStock = {
  name: "markPickSessionItemInStock" as const,
  input: z.object({ pickSessionId: zExt.objectId(), itemId: zExt.objectId() }),
  output: z.object({
    success: z.boolean(),
    updatedPickSession: PickSessionSchema.nullish(),
  }),
};
